import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { delay } from "lodash-es";
import { useSize } from "ahooks";

import "./index.less";
const prefix = "ecological-tabs";

type Porps = {
  current: string;
  list: any[];
  onChange: (e: any) => void;
};

const EcologicalTabs: React.FC<Porps> = (props: Porps) => {
  const { current, list, onChange } = props;
  const [active, setActive] = useState<string>(list[0].key);
  const [bgLeft, setBgLeft] = useState<number>(0);
  const [isFixedTop, setIsFixedTop] = useState<boolean>(false);
  const [isClick, setIsClick] = useState<boolean>(false);
  const innerRef = useRef(null);
  const innerSize: any = useSize(innerRef);

  const dispatch = useDispatch();
  const scrollHeight = useSelector((state: any) => state.scrollHeight);

  const hasIcon = list.some((item) => item?.icon);
  const length = list.length;

  const handleClick = (item: any) => {
    setIsClick(true);
    setActive(item.key);
    setBgLeft((getIndex(item.key) * innerSize?.width) / length);
    delay(() => {
      setIsClick(false);
    }, 300);
    onChange(item);
    dispatch({
      type: "setIsClickCauseScroll",
      payload: true,
    });
  };

  const getIndex = (item: any) => {
    return list.findIndex((ele) => ele.key == item);
  };

  useEffect(() => {
    innerSize?.width && setBgLeft((getIndex(active) * innerSize?.width) / length);
  }, [innerSize?.width]);

  useEffect(() => {
    setIsFixedTop(scrollHeight > 480);
  }, [scrollHeight]);

  useEffect(() => {
    if (!isClick && current) {
      setActive(current);
      setBgLeft((getIndex(current) * innerSize?.width) / length);
    }
  }, [current]);

  return (
    <div className={`${prefix} ${isFixedTop ? "fixedTop" : ""}`}>
      <div className={`${prefix}-inner`} ref={innerRef}>
        {!hasIcon ? (
          <div className={`${prefix}-bg`} style={{ left: bgLeft, width: `${Math.trunc(100 / length)}%` }}></div>
        ) : null}
        <div className={`${prefix}-wrap`}>
          {hasIcon
            ? list.map((item, index) => {
                return (
                  <div
                    key={item.key}
                    onClick={() => {
                      handleClick(item);
                    }}
                    className={`${prefix}-item2`}
                  >
                    <div className={`${prefix}-item2-text ${active == item.key ? "on" : ""}`}>
                      <div className={`${prefix}-img-box`}>
                        <img src={item.icon} alt="" style={{ width: item.iconW, height: item.iconH }} />
                      </div>

                      <span>{item.title}</span>
                    </div>
                    {index + 1 < length ? (
                      <span
                        className={`${prefix}-line ${
                          getIndex(active) - 1 == index || active == item.key ? "opacity0" : ""
                        }`}
                      ></span>
                    ) : null}
                  </div>
                );
              })
            : list.map((item, index) => {
                return (
                  <div
                    key={item.key}
                    className={`${prefix}-item ${active == item.key ? "on" : ""}`}
                    style={{ width: `${Math.trunc(100 / length)}%` }}
                    onClick={() => {
                      handleClick(item);
                    }}
                  >
                    <div className={`${prefix}-item-text ${active == item.key ? "on" : ""}`}>{item.title}</div>
                    {index + 1 < length ? (
                      <span
                        className={`${prefix}-line ${
                          getIndex(active) - 1 == index || active == item.key ? "opacity0" : ""
                        }`}
                      ></span>
                    ) : null}
                  </div>
                );
              })}
        </div>
      </div>
    </div>
  );
};
export default EcologicalTabs;
